/* unplugin-vue-components disabled */import { render } from "./xswitch.vue?vue&type=template&id=68021b5a"
import script from "./xswitch.vue?vue&type=script&lang=js"
export * from "./xswitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__